module.exports = __webpack_public_path__ + "img/banner-fr.1fd36479.jpg";